import dayjs from "dayjs"
import isSameOrBefore from "dayjs/plugin/isSameOrBefore"
import timezone from "dayjs/plugin/timezone"
import updateLocale from "dayjs/plugin/updateLocale"
import utc from "dayjs/plugin/utc"
import weekday from "dayjs/plugin/weekday"
import weekOfYear from "dayjs/plugin/weekOfYear"

dayjs.extend(isSameOrBefore)
dayjs.extend(timezone)
dayjs.extend(updateLocale)
dayjs.extend(utc)
dayjs.extend(weekday)
dayjs.extend(weekOfYear)

import { useCallback } from "react"
import { useCurrentOrganizationTimeZone } from "source/calendar/hooks/useCurrentOrganizationTimeZone"
import { useChurchCenterConfiguration } from "./useChurchCenterConfiguration"

export function useDayjsInTimeZone() {
  const timeZone = useCurrentOrganizationTimeZone()
  const { weekStartsOnInt } = useChurchCenterConfiguration()

  return useCallback(
    (date) => {
      // Set first day of week for locale (0 = Sunday, 1 = Monday, etc.)
      dayjs.updateLocale("en", {
        weekStart: weekStartsOnInt,
      })

      return dayjs(date).tz(timeZone)
    },
    [timeZone, weekStartsOnInt],
  )
}
